import { appInfo } from "@/common/data"; 
export default [
    {
            path: "/00a136fd440a0e03bf5cd2fdd7889d882189cfa73be8ba1d",
            children: [
              {
                path: "/00a136fd440a0e2483eddf487a123dae5d20cfa73be8ba1d",
                name: "baice26.gazettes",
                component: () => import("@/views/baice/tws/gazette/list.vue"),
                meta: {
                  title:
                    appInfo?.type == "codemsi"
                      ? "SAISSCE 2026 Gazettes"
                      : "BAICE 2026 Gazettes",
                  authRequired: true,
                  acc: ["y11545"],
                },
              },
              {
                path: "/0e4052980eed4276f28dfa47",
                name: "baice26.pendinggazettereq",
                component: () =>
                  import("@/views/baice/tws/gazette/pendingrequests.vue"),
                meta: {
                  title:
                    appInfo?.type == "codemsi"
                      ? "SAISSCE 2026 Pending Gazette Requests"
                      : "BAICE 2026 Pending Gazette Requests",
                  authRequired: true,
                  acc: ["y68100"],
                },
              },
              {
                path: "/011029aeaf4da445c1fe174a",
                name: "baice26.uploadgazette",
                component: () => import("@/views/baice/tws/gazette/upload.vue"),
                meta: {
                  title:
                    appInfo?.type == "codemsi"
                      ? "Upload SAISSCE 2026 Gazette"
                      : "Upload BAICE 2026 Gazette",
                  authRequired: true,
                  acc: ["y88267"],
                },
              },
              {
                path: "/016ec794840ef1d1a109ef1a9878cd2b011a964450b74d24",
                name: "baice26.uploadedgazettes",
                component: () =>
                  import("@/views/baice/tws/gazette/uploaded-gazette.vue"),
                meta: {
                  title:
                    appInfo?.type == "codemsi"
                      ? "Uploaded SAISSCE 2026 Gazettes"
                      : "Uploaded BAICE 2026 Gazettes",
                  authRequired: true,
                  acc: ["y10535"],
                },
              },
              {
                path: "/0f2157d00212e12fbc232005/:er?",
                name: "baice26.gazette",
                component: () => import("@/views/baice/tws/gazette/vgazette.vue"),
                meta: {
                  title:
                    appInfo?.type == "codemsi"
                      ? "Print SAISSCE Gazette"
                      : "Print BAICE Gazette",
                  authRequired: true,
                  acc: ["y73911"],
                },
              },
            ],
          },

]